module.exports = __webpack_public_path__ + "static/media/25.ac7d3202.JPG";